export class EnumHelper {
  // get the enum key by value
  static getKey(enumValue) {
    return Object.keys(this).find(key => this[key] === enumValue)
  }
}
